import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const money = (cents) => (cents == null ? "" : `$${(cents / 100).toFixed(cents % 100 ? 2 : 0)}`);
export const imgUrl = (src) => (src && src.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${src}` : src);

let cache = null;
export const useProducts = () => {
  const [products, setProducts] = useState(cache);
  useEffect(() => {
    if (cache) return;
    axios.get(`${API}/products`).then((r) => {
      cache = r.data;
      setProducts(r.data);
    }).catch(() => setProducts([]));
  }, []);
  return products || [];
};

let catCache = null;
export const useCategories = () => {
  const [cats, setCats] = useState(catCache);
  useEffect(() => {
    if (catCache) return;
    axios.get(`${API}/categories`).then((r) => {
      catCache = r.data;
      setCats(r.data);
    }).catch(() => setCats([]));
  }, []);
  return cats || [];
};
export const refreshCategories = async () => {
  const r = await axios.get(`${API}/categories`);
  catCache = r.data;
  return r.data;
};
